import { render, staticRenderFns } from "./FormPage3.vue?vue&type=template&id=488e1b08&scoped=true&"
import script from "./FormPage3.vue?vue&type=script&lang=js&"
export * from "./FormPage3.vue?vue&type=script&lang=js&"
import style0 from "./FormPage3.vue?vue&type=style&index=0&id=488e1b08&scoped=true&lang=css&"
import style1 from "./FormPage3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e1b08",
  null
  
)

export default component.exports